export type CountryData = {
  dutchName: string;
  localName: string;
  phonePrefix: string;
  englishName: string;
};

export const countries: Record<string, CountryData> = {
  AF: {
    dutchName: "Afghanistan",
    localName: "افغانستان",
    phonePrefix: "93",
    englishName: "Afghanistan",
  },
  AL: {
    dutchName: "Albanië",
    localName: "Shqipëria",
    phonePrefix: "355",
    englishName: "Albania",
  },
  DZ: {
    dutchName: "Algerije",
    localName: "الجزائر",
    phonePrefix: "213",
    englishName: "Algeria",
  },
  AS: {
    dutchName: "Amerikaans-Samoa",
    localName: "American Samoa",
    phonePrefix: "1684",
    englishName: "American Samoa",
  },
  VI: {
    dutchName: "Amerikaanse Maagdeneilanden",
    localName: "U.S. Virgin Islands",
    phonePrefix: "1340",
    englishName: "U.S. Virgin Islands",
  },
  AD: {
    dutchName: "Andorra",
    localName: "Andorra",
    phonePrefix: "376",
    englishName: "Andorra",
  },
  AO: {
    dutchName: "Angola",
    localName: "Angola",
    phonePrefix: "244",
    englishName: "Angola",
  },
  AI: {
    dutchName: "Anguilla",
    localName: "Anguilla",
    phonePrefix: "1264",
    englishName: "Anguilla",
  },
  AQ: {
    dutchName: "Antarctica",
    localName: "Antarctica",
    phonePrefix: "672",
    englishName: "Antarctica",
  },
  AG: {
    dutchName: "Antigua en Barbuda",
    localName: "Antigua and Barbuda",
    phonePrefix: "1268",
    englishName: "Antigua and Barbuda",
  },
  AR: {
    dutchName: "Argentinië",
    localName: "Argentina",
    phonePrefix: "54",
    englishName: "Argentina",
  },
  AM: {
    dutchName: "Armenië",
    localName: "Հայաստան",
    phonePrefix: "374",
    englishName: "Armenia",
  },
  AW: {
    dutchName: "Aruba",
    localName: "Aruba",
    phonePrefix: "297",
    englishName: "Aruba",
  },
  AU: {
    dutchName: "Australië",
    localName: "Australia",
    phonePrefix: "61",
    englishName: "Australia",
  },
  AZ: {
    dutchName: "Azerbeidzjan",
    localName: "Azərbaycan",
    phonePrefix: "994",
    englishName: "Azerbaijan",
  },
  BS: {
    dutchName: "Bahama's",
    localName: "The Bahamas",
    phonePrefix: "1242",
    englishName: "The Bahamas",
  },
  BH: {
    dutchName: "Bahrein",
    localName: "البحرين",
    phonePrefix: "973",
    englishName: "Bahrain",
  },
  BD: {
    dutchName: "Bangladesh",
    localName: "বাংলাদেশ",
    phonePrefix: "880",
    englishName: "Bangladesh",
  },
  BB: {
    dutchName: "Barbados",
    localName: "Barbados",
    phonePrefix: "1246",
    englishName: "Barbados",
  },
  BE: {
    dutchName: "België",
    localName: "België/Belgique/Belgien",
    phonePrefix: "32",
    englishName: "Belgium",
  },
  BZ: {
    dutchName: "Belize",
    localName: "Belize",
    phonePrefix: "501",
    englishName: "Belize",
  },
  BJ: {
    dutchName: "Benin",
    localName: "Bénin",
    phonePrefix: "229",
    englishName: "Benin",
  },
  BM: {
    dutchName: "Bermuda",
    localName: "Bermuda",
    phonePrefix: "1441",
    englishName: "Bermuda",
  },
  BT: {
    dutchName: "Bhutan",
    localName: "འབྲུག་ཡུལ",
    phonePrefix: "975",
    englishName: "Bhutan",
  },
  BO: {
    dutchName: "Bolivia",
    localName: "Bolivia",
    phonePrefix: "591",
    englishName: "Bolivia",
  },
  BQ: {
    dutchName: "Bonaire, Sint Eustatius en Saba",
    localName: "Bonaire, Sint Eustatius and Saba",
    phonePrefix: "599",
    englishName: "Bonaire, Sint Eustatius and Saba",
  },
  BA: {
    dutchName: "Bosnië Herzegovina",
    localName: "Bosna i Hercegovina",
    phonePrefix: "387",
    englishName: "Bosnia and Herzegovina",
  },
  BW: {
    dutchName: "Botswana",
    localName: "Botswana",
    phonePrefix: "267",
    englishName: "Botswana",
  },
  BV: {
    dutchName: "Bouveteiland",
    localName: "Bouvetøya",
    phonePrefix: "",
    englishName: "Bouvet Island",
  },
  BR: {
    dutchName: "Brazilië",
    localName: "Brasil",
    phonePrefix: "55",
    englishName: "Brazil",
  },
  IO: {
    dutchName: "Brits Indische Oceaanterritorium",
    localName: "British Indian Ocean Territory",
    phonePrefix: "246",
    englishName: "British Indian Ocean Territory",
  },
  VG: {
    dutchName: "Britse Maagdeneilanden",
    localName: "British Virgin Islands",
    phonePrefix: "1284",
    englishName: "British Virgin Islands",
  },
  BN: {
    dutchName: "Brunei",
    localName: "Brunei Darussalam",
    phonePrefix: "673",
    englishName: "Brunei",
  },
  BG: {
    dutchName: "Bulgarije",
    localName: "България",
    phonePrefix: "359",
    englishName: "Bulgaria",
  },
  BF: {
    dutchName: "Burkina Faso",
    localName: "Burkina Faso",
    phonePrefix: "226",
    englishName: "Burkina Faso",
  },
  BI: {
    dutchName: "Burundi",
    localName: "Burundi",
    phonePrefix: "257",
    englishName: "Burundi",
  },
  KH: {
    dutchName: "Cambodja",
    localName: "កម្ពុជា",
    phonePrefix: "855",
    englishName: "Cambodia",
  },
  CA: {
    dutchName: "Canada",
    localName: "Canada",
    phonePrefix: "1",
    englishName: "Canada",
  },
  CF: {
    dutchName: "Centraal-Afrikaanse Republiek",
    localName: "République centrafricaine",
    phonePrefix: "236",
    englishName: "Central African Republic",
  },
  CL: {
    dutchName: "Chili",
    localName: "Chile",
    phonePrefix: "56",
    englishName: "Chile",
  },
  CN: {
    dutchName: "China",
    localName: "中国",
    phonePrefix: "86",
    englishName: "China",
  },
  CX: {
    dutchName: "Christmaseiland",
    localName: "Christmas Island",
    phonePrefix: "61",
    englishName: "Christmas Island",
  },
  CC: {
    dutchName: "Cocoseilanden",
    localName: "Cocos (Keeling) Islands",
    phonePrefix: "61",
    englishName: "Cocos (Keeling) Islands",
  },
  CO: {
    dutchName: "Colombia",
    localName: "Colombia",
    phonePrefix: "57",
    englishName: "Colombia",
  },
  KM: {
    dutchName: "Comoren",
    localName: "Komori/Comores",
    phonePrefix: "269",
    englishName: "Comoros",
  },
  CD: {
    dutchName: "Congo-Kinshasa",
    localName: "République démocratique du Congo",
    phonePrefix: "243",
    englishName: "Congo-Kinshasa",
  },
  CK: {
    dutchName: "Cookeilanden",
    localName: "Cook Islands",
    phonePrefix: "682",
    englishName: "Cook Islands",
  },
  CR: {
    dutchName: "Costa Rica",
    localName: "Costa Rica",
    phonePrefix: "506",
    englishName: "Costa Rica",
  },
  CU: {
    dutchName: "Cuba",
    localName: "Cuba",
    phonePrefix: "53",
    englishName: "Cuba",
  },
  CW: {
    dutchName: "Curaçao",
    localName: "Curaçao",
    phonePrefix: "599",
    englishName: "Curaçao",
  },
  CY: {
    dutchName: "Cyprus",
    localName: "Κύπρος/Kıbrıs",
    phonePrefix: "357",
    englishName: "Cyprus",
  },
  DK: {
    dutchName: "Denemarken",
    localName: "Danmark",
    phonePrefix: "45",
    englishName: "Denmark",
  },
  DJ: {
    dutchName: "Djibouti",
    localName: "جيبوتي/Djibouti",
    phonePrefix: "253",
    englishName: "Djibouti",
  },
  DM: {
    dutchName: "Dominica",
    localName: "Dominica",
    phonePrefix: "1767",
    englishName: "Dominica",
  },
  DO: {
    dutchName: "Dominicaanse Republiek",
    localName: "República Dominicana",
    phonePrefix: "1809",
    englishName: "Dominican Republic",
  },
  DE: {
    dutchName: "Duitsland",
    localName: "Deutschland",
    phonePrefix: "49",
    englishName: "Germany",
  },
  EC: {
    dutchName: "Ecuador",
    localName: "Ecuador",
    phonePrefix: "593",
    englishName: "Ecuador",
  },
  EG: {
    dutchName: "Egypte",
    localName: "مصر",
    phonePrefix: "20",
    englishName: "Egypt",
  },
  SV: {
    dutchName: "El Salvador",
    localName: "El Salvador",
    phonePrefix: "503",
    englishName: "El Salvador",
  },
  GQ: {
    dutchName: "Equatoriaal-Guinea",
    localName: "Guinea Ecuatorial",
    phonePrefix: "240",
    englishName: "Equatorial Guinea",
  },
  ER: {
    dutchName: "Eritrea",
    localName: "ኤርትራ/إرتريا",
    phonePrefix: "291",
    englishName: "Eritrea",
  },
  EE: {
    dutchName: "Estland",
    localName: "Eesti",
    phonePrefix: "372",
    englishName: "Estonia",
  },
  ET: {
    dutchName: "Ethiopië",
    localName: "ኢትዮጵያ",
    phonePrefix: "251",
    englishName: "Ethiopia",
  },
  FO: {
    dutchName: "Faeröer",
    localName: "Føroyar",
    phonePrefix: "298",
    englishName: "Faroe Islands",
  },
  FK: {
    dutchName: "Falklandeilanden",
    localName: "Falkland Islands",
    phonePrefix: "500",
    englishName: "Falkland Islands",
  },
  FJ: {
    dutchName: "Fiji",
    localName: "Fiji",
    phonePrefix: "679",
    englishName: "Fiji",
  },
  PH: {
    dutchName: "Filipijnen",
    localName: "Philippines/Pilipinas",
    phonePrefix: "63",
    englishName: "Philippines",
  },
  FI: {
    dutchName: "Finland",
    localName: "Suomi",
    phonePrefix: "358",
    englishName: "Finland",
  },
  FR: {
    dutchName: "Frankrijk",
    localName: "France",
    phonePrefix: "33",
    englishName: "France",
  },
  GF: {
    dutchName: "Frans-Guyana",
    localName: "Guyane française",
    phonePrefix: "594",
    englishName: "French Guiana",
  },
  PF: {
    dutchName: "Frans-Polynesië",
    localName: "Polynésie française",
    phonePrefix: "689",
    englishName: "French Polynesia",
  },
  TF: {
    dutchName: "Franse Zuidelijke en Antarctische Gebieden",
    localName: "Terres australes et antarctiques françaises",
    phonePrefix: "262",
    englishName: "French Southern and Antarctic Lands",
  },
  GA: {
    dutchName: "Gabon",
    localName: "Gabon",
    phonePrefix: "241",
    englishName: "Gabon",
  },
  GM: {
    dutchName: "Gambia",
    localName: "The Gambia",
    phonePrefix: "220",
    englishName: "Gambia",
  },
  GE: {
    dutchName: "Georgië",
    localName: "საქართველო",
    phonePrefix: "995",
    englishName: "Georgia",
  },
  GH: {
    dutchName: "Ghana",
    localName: "Ghana",
    phonePrefix: "233",
    englishName: "Ghana",
  },
  GI: {
    dutchName: "Gibraltar",
    localName: "Gibraltar",
    phonePrefix: "350",
    englishName: "Gibraltar",
  },
  GD: {
    dutchName: "Grenada",
    localName: "Grenada",
    phonePrefix: "1473",
    englishName: "Grenada",
  },
  GR: {
    dutchName: "Griekenland",
    localName: "Ελλάδα",
    phonePrefix: "30",
    englishName: "Greece",
  },
  GL: {
    dutchName: "Groenland",
    localName: "Kalaallit Nunaat",
    phonePrefix: "299",
    englishName: "Greenland",
  },
  GP: {
    dutchName: "Guadeloupe",
    localName: "Guadeloupe",
    phonePrefix: "590",
    englishName: "Guadeloupe",
  },
  GU: {
    dutchName: "Guam",
    localName: "Guam",
    phonePrefix: "1671",
    englishName: "Guam",
  },
  GT: {
    dutchName: "Guatemala",
    localName: "Guatemala",
    phonePrefix: "502",
    englishName: "Guatemala",
  },
  GG: {
    dutchName: "Guernsey",
    localName: "Guernsey",
    phonePrefix: "44",
    englishName: "Guernsey",
  },
  GN: {
    dutchName: "Guinee",
    localName: "Guinée",
    phonePrefix: "224",
    englishName: "Guinea",
  },
  GW: {
    dutchName: "Guinee-Bissau",
    localName: "Guiné-Bissau",
    phonePrefix: "245",
    englishName: "Guinea-Bissau",
  },
  GY: {
    dutchName: "Guyana",
    localName: "Guyana",
    phonePrefix: "592",
    englishName: "Guyana",
  },
  HT: {
    dutchName: "Haïti",
    localName: "Haïti",
    phonePrefix: "509",
    englishName: "Haiti",
  },
  HM: {
    dutchName: "Heard en McDonaldeilanden",
    localName: "Heard Island and McDonald Islands",
    phonePrefix: "672",
    englishName: "Heard Island and McDonald Islands",
  },
  HN: {
    dutchName: "Honduras",
    localName: "Honduras",
    phonePrefix: "504",
    englishName: "Honduras",
  },
  HK: {
    dutchName: "Hongkong",
    localName: "香港",
    phonePrefix: "852",
    englishName: "Hong Kong",
  },
  IS: {
    dutchName: "IJsland",
    localName: "Ísland",
    phonePrefix: "354",
    englishName: "Iceland",
  },
  IE: {
    dutchName: "Ierland",
    localName: "Ireland/Éire",
    phonePrefix: "353",
    englishName: "Ireland",
  },
  IN: {
    dutchName: "India",
    localName: "भारत",
    phonePrefix: "91",
    englishName: "India",
  },
  ID: {
    dutchName: "Indonesië",
    localName: "Indonesia",
    phonePrefix: "62",
    englishName: "Indonesia",
  },
  IQ: {
    dutchName: "Irak",
    localName: "العراق",
    phonePrefix: "964",
    englishName: "Iraq",
  },
  IR: {
    dutchName: "Iran",
    localName: "ایران",
    phonePrefix: "98",
    englishName: "Iran",
  },
  IL: {
    dutchName: "Israël",
    localName: "ישראל",
    phonePrefix: "972",
    englishName: "Israel",
  },
  IT: {
    dutchName: "Italië",
    localName: "Italia",
    phonePrefix: "39",
    englishName: "Italy",
  },
  CI: {
    dutchName: "Ivoorkust",
    localName: "Côte d'Ivoire",
    phonePrefix: "225",
    englishName: "Ivory Coast",
  },
  JM: {
    dutchName: "Jamaica",
    localName: "Jamaica",
    phonePrefix: "1876",
    englishName: "Jamaica",
  },
  JP: {
    dutchName: "Japan",
    localName: "日本",
    phonePrefix: "81",
    englishName: "Japan",
  },
  YE: {
    dutchName: "Jemen",
    localName: "اليمن",
    phonePrefix: "967",
    englishName: "Yemen",
  },
  JE: {
    dutchName: "Jersey",
    localName: "Jersey",
    phonePrefix: "44",
    englishName: "Jersey",
  },
  JO: {
    dutchName: "Jordanië",
    localName: "الأردن",
    phonePrefix: "962",
    englishName: "Jordan",
  },
  KY: {
    dutchName: "Kaaimaneilanden",
    localName: "Cayman Islands",
    phonePrefix: "1345",
    englishName: "Cayman Islands",
  },
  CV: {
    dutchName: "Kaapverdië",
    localName: "Cabo Verde",
    phonePrefix: "238",
    englishName: "Cape Verde",
  },
  CM: {
    dutchName: "Kameroen",
    localName: "Cameroun",
    phonePrefix: "237",
    englishName: "Cameroon",
  },
  KZ: {
    dutchName: "Kazachstan",
    localName: "Қазақстан",
    phonePrefix: "7",
    englishName: "Kazakhstan",
  },
  KE: {
    dutchName: "Kenia",
    localName: "Kenya",
    phonePrefix: "254",
    englishName: "Kenya",
  },
  KG: {
    dutchName: "Kirgizië",
    localName: "Кыргызстан",
    phonePrefix: "996",
    englishName: "Kyrgyzstan",
  },
  KI: {
    dutchName: "Kiribati",
    localName: "Kiribati",
    phonePrefix: "686",
    englishName: "Kiribati",
  },
  UM: {
    dutchName: "Kleine Pacifische eilanden van de Verenigde Staten",
    localName: "United States Minor Outlying Islands",
    phonePrefix: "1",
    englishName: "United States Minor Outlying Islands",
  },
  KW: {
    dutchName: "Koeweit",
    localName: "الكويت",
    phonePrefix: "965",
    englishName: "Kuwait",
  },
  HR: {
    dutchName: "Kroatië",
    localName: "Hrvatska",
    phonePrefix: "385",
    englishName: "Croatia",
  },
  LA: {
    dutchName: "Laos",
    localName: "ລາວ",
    phonePrefix: "856",
    englishName: "Laos",
  },
  LS: {
    dutchName: "Lesotho",
    localName: "Lesotho",
    phonePrefix: "266",
    englishName: "Lesotho",
  },
  LV: {
    dutchName: "Letland",
    localName: "Latvija",
    phonePrefix: "371",
    englishName: "Latvia",
  },
  LB: {
    dutchName: "Libanon",
    localName: "لبنان",
    phonePrefix: "961",
    englishName: "Lebanon",
  },
  LR: {
    dutchName: "Liberia",
    localName: "Liberia",
    phonePrefix: "231",
    englishName: "Liberia",
  },
  LY: {
    dutchName: "Libië",
    localName: "ليبيا",
    phonePrefix: "218",
    englishName: "Libya",
  },
  LI: {
    dutchName: "Liechtenstein",
    localName: "Liechtenstein",
    phonePrefix: "423",
    englishName: "Liechtenstein",
  },
  LT: {
    dutchName: "Litouwen",
    localName: "Lietuva",
    phonePrefix: "370",
    englishName: "Lithuania",
  },
  LU: {
    dutchName: "Luxemburg",
    localName: "Luxembourg",
    phonePrefix: "352",
    englishName: "Luxembourg",
  },
  MO: {
    dutchName: "Macau",
    localName: "澳門",
    phonePrefix: "853",
    englishName: "Macau",
  },
  MG: {
    dutchName: "Madagaskar",
    localName: "Madagascar",
    phonePrefix: "261",
    englishName: "Madagascar",
  },
  MW: {
    dutchName: "Malawi",
    localName: "Malawi",
    phonePrefix: "265",
    englishName: "Malawi",
  },
  MV: {
    dutchName: "Maldiven",
    localName: "ދިވެހިރާއްޖެ",
    phonePrefix: "960",
    englishName: "Maldives",
  },
  MY: {
    dutchName: "Maleisië",
    localName: "Malaysia",
    phonePrefix: "60",
    englishName: "Malaysia",
  },
  ML: {
    dutchName: "Mali",
    localName: "Mali",
    phonePrefix: "223",
    englishName: "Mali",
  },
  MT: {
    dutchName: "Malta",
    localName: "Malta",
    phonePrefix: "356",
    englishName: "Malta",
  },
  IM: {
    dutchName: "Man",
    localName: "Isle of Man",
    phonePrefix: "44",
    englishName: "Isle of Man",
  },
  MA: {
    dutchName: "Marokko",
    localName: "المغرب",
    phonePrefix: "212",
    englishName: "Morocco",
  },
  MH: {
    dutchName: "Marshalleilanden",
    localName: "Marshall Islands",
    phonePrefix: "692",
    englishName: "Marshall Islands",
  },
  MQ: {
    dutchName: "Martinique",
    localName: "Martinique",
    phonePrefix: "596",
    englishName: "Martinique",
  },
  MR: {
    dutchName: "Mauritanië",
    localName: "موريتانيا",
    phonePrefix: "222",
    englishName: "Mauritania",
  },
  MU: {
    dutchName: "Mauritius",
    localName: "Mauritius",
    phonePrefix: "230",
    englishName: "Mauritius",
  },
  YT: {
    dutchName: "Mayotte",
    localName: "Mayotte",
    phonePrefix: "262",
    englishName: "Mayotte",
  },
  MX: {
    dutchName: "Mexico",
    localName: "México",
    phonePrefix: "52",
    englishName: "Mexico",
  },
  FM: {
    dutchName: "Micronesia",
    localName: "Micronesia",
    phonePrefix: "691",
    englishName: "Micronesia",
  },
  MD: {
    dutchName: "Moldavië",
    localName: "Moldova",
    phonePrefix: "373",
    englishName: "Moldova",
  },
  MC: {
    dutchName: "Monaco",
    localName: "Monaco",
    phonePrefix: "377",
    englishName: "Monaco",
  },
  MN: {
    dutchName: "Mongolië",
    localName: "Монгол",
    phonePrefix: "976",
    englishName: "Mongolia",
  },
  ME: {
    dutchName: "Montenegro",
    localName: "Црна Гора",
    phonePrefix: "382",
    englishName: "Montenegro",
  },
  MS: {
    dutchName: "Montserrat",
    localName: "Montserrat",
    phonePrefix: "1664",
    englishName: "Montserrat",
  },
  NF: {
    dutchName: "Norfolk",
    localName: "Norfolk Island",
    phonePrefix: "672",
    englishName: "Norfolk Island",
  },
  UG: {
    dutchName: "Oeganda",
    localName: "Uganda",
    phonePrefix: "256",
    englishName: "Uganda",
  },
  UA: {
    dutchName: "Oekraïne",
    localName: "Україна",
    phonePrefix: "380",
    englishName: "Ukraine",
  },
  UZ: {
    dutchName: "Oezbekistan",
    localName: "O'zbekiston",
    phonePrefix: "998",
    englishName: "Uzbekistan",
  },
  OM: {
    dutchName: "Oman",
    localName: "عمان",
    phonePrefix: "968",
    englishName: "Oman",
  },
  TL: {
    dutchName: "Oost-Timor",
    localName: "Timor-Leste",
    phonePrefix: "670",
    englishName: "East Timor",
  },
  AT: {
    dutchName: "Oostenrijk",
    localName: "Österreich",
    phonePrefix: "43",
    englishName: "Austria",
  },
  PK: {
    dutchName: "Pakistan",
    localName: "پاکستان",
    phonePrefix: "92",
    englishName: "Pakistan",
  },
  PW: {
    dutchName: "Palau",
    localName: "Palau",
    phonePrefix: "680",
    englishName: "Palau",
  },
  PS: {
    dutchName: "Palestina",
    localName: "فلسطين",
    phonePrefix: "970",
    englishName: "Palestine",
  },
  PA: {
    dutchName: "Panama",
    localName: "Panamá",
    phonePrefix: "507",
    englishName: "Panama",
  },
  PG: {
    dutchName: "Papoea-Nieuw-Guinea",
    localName: "Papua New Guinea",
    phonePrefix: "675",
    englishName: "Papua New Guinea",
  },
  PY: {
    dutchName: "Paraguay",
    localName: "Paraguay",
    phonePrefix: "595",
    englishName: "Paraguay",
  },
  PE: {
    dutchName: "Peru",
    localName: "Perú",
    phonePrefix: "51",
    englishName: "Peru",
  },
  PN: {
    dutchName: "Pitcairneilanden",
    localName: "Pitcairn Islands",
    phonePrefix: "64",
    englishName: "Pitcairn Islands",
  },
  PL: {
    dutchName: "Polen",
    localName: "Polska",
    phonePrefix: "48",
    englishName: "Poland",
  },
  PT: {
    dutchName: "Portugal",
    localName: "Portugal",
    phonePrefix: "351",
    englishName: "Portugal",
  },
  PR: {
    dutchName: "Puerto Rico",
    localName: "Puerto Rico",
    phonePrefix: "1787",
    englishName: "Puerto Rico",
  },
  QA: {
    dutchName: "Qatar",
    localName: "قطر",
    phonePrefix: "974",
    englishName: "Qatar",
  },
  CG: {
    dutchName: "Republiek Congo",
    localName: "République du Congo",
    phonePrefix: "242",
    englishName: "Republic of the Congo",
  },
  RO: {
    dutchName: "Roemenië",
    localName: "România",
    phonePrefix: "40",
    englishName: "Romania",
  },
  RU: {
    dutchName: "Rusland",
    localName: "Россия",
    phonePrefix: "7",
    englishName: "Russia",
  },
  RW: {
    dutchName: "Rwanda",
    localName: "Rwanda",
    phonePrefix: "250",
    englishName: "Rwanda",
  },
  RE: {
    dutchName: "Réunion",
    localName: "La Réunion",
    phonePrefix: "262",
    englishName: "Réunion",
  },
  KN: {
    dutchName: "Saint Kitts en Nevis",
    localName: "Saint Kitts and Nevis",
    phonePrefix: "1869",
    englishName: "Saint Kitts and Nevis",
  },
  LC: {
    dutchName: "Saint Lucia",
    localName: "Saint Lucia",
    phonePrefix: "1758",
    englishName: "Saint Lucia",
  },
  VC: {
    dutchName: "Saint Vincent en de Grenadines",
    localName: "Saint Vincent and the Grenadines",
    phonePrefix: "1784",
    englishName: "Saint Vincent and the Grenadines",
  },
  BL: {
    dutchName: "Saint-Barthélemy",
    localName: "Saint-Barthélemy",
    phonePrefix: "590",
    englishName: "Saint Barthélemy",
  },
  PM: {
    dutchName: "Saint-Pierre en Miquelon",
    localName: "Saint-Pierre-et-Miquelon",
    phonePrefix: "508",
    englishName: "Saint Pierre and Miquelon",
  },
  SB: {
    dutchName: "Salomonseilanden",
    localName: "Solomon Islands",
    phonePrefix: "677",
    englishName: "Solomon Islands",
  },
  WS: {
    dutchName: "Samoa",
    localName: "Samoa",
    phonePrefix: "685",
    englishName: "Samoa",
  },
  SM: {
    dutchName: "San Marino",
    localName: "San Marino",
    phonePrefix: "378",
    englishName: "San Marino",
  },
  ST: {
    dutchName: "Sao Tomé en Principe",
    localName: "São Tomé e Príncipe",
    phonePrefix: "239",
    englishName: "São Tomé and Príncipe",
  },
  SA: {
    dutchName: "Saoedi-Arabië",
    localName: "المملكة العربية السعودية",
    phonePrefix: "966",
    englishName: "Saudi Arabia",
  },
  SN: {
    dutchName: "Senegal",
    localName: "Sénégal",
    phonePrefix: "221",
    englishName: "Senegal",
  },
  RS: {
    dutchName: "Servië",
    localName: "Србија",
    phonePrefix: "381",
    englishName: "Serbia",
  },
  SC: {
    dutchName: "Seychellen",
    localName: "Seychelles",
    phonePrefix: "248",
    englishName: "Seychelles",
  },
  SL: {
    dutchName: "Sierra Leone",
    localName: "Sierra Leone",
    phonePrefix: "232",
    englishName: "Sierra Leone",
  },
  SG: {
    dutchName: "Singapore",
    localName: "Singapore",
    phonePrefix: "65",
    englishName: "Singapore",
  },
  SH: {
    dutchName: "Sint-Helena, Ascension en Tristan da Cunha",
    localName: "Saint Helena, Ascension and Tristan da Cunha",
    phonePrefix: "290",
    englishName: "Saint Helena, Ascension and Tristan da Cunha",
  },
  MF: {
    dutchName: "Sint-Maarten (FR)",
    localName: "Saint-Martin",
    phonePrefix: "590",
    englishName: "Saint Martin (French part)",
  },
  SX: {
    dutchName: "Sint-Maarten (NL)",
    localName: "Sint Maarten",
    phonePrefix: "1721",
    englishName: "Sint Maarten (Dutch part)",
  },
  SI: {
    dutchName: "Slovenië",
    localName: "Slovenija",
    phonePrefix: "386",
    englishName: "Slovenia",
  },
  SK: {
    dutchName: "Slowakije",
    localName: "Slovensko",
    phonePrefix: "421",
    englishName: "Slovakia",
  },
  SD: {
    dutchName: "Soedan",
    localName: "السودان",
    phonePrefix: "249",
    englishName: "Sudan",
  },
  SO: {
    dutchName: "Somalië",
    localName: "Soomaaliya",
    phonePrefix: "252",
    englishName: "Somalia",
  },
  ES: {
    dutchName: "Spanje",
    localName: "España",
    phonePrefix: "34",
    englishName: "Spain",
  },
  SJ: {
    dutchName: "Spitsbergen en Jan Mayen",
    localName: "Svalbard and Jan Mayen",
    phonePrefix: "47",
    englishName: "Svalbard and Jan Mayen",
  },
  LK: {
    dutchName: "Sri Lanka",
    localName: "ශ්‍රී ලංකාව",
    phonePrefix: "94",
    englishName: "Sri Lanka",
  },
  SR: {
    dutchName: "Suriname",
    localName: "Suriname",
    phonePrefix: "597",
    englishName: "Suriname",
  },
  SZ: {
    dutchName: "Swaziland",
    localName: "Eswatini",
    phonePrefix: "268",
    englishName: "Eswatini",
  },
  SY: {
    dutchName: "Syrië",
    localName: "سوريا",
    phonePrefix: "963",
    englishName: "Syria",
  },
  TJ: {
    dutchName: "Tadzjikistan",
    localName: "Тоҷикистон",
    phonePrefix: "992",
    englishName: "Tajikistan",
  },
  TW: {
    dutchName: "Taiwan",
    localName: "台灣",
    phonePrefix: "886",
    englishName: "Taiwan",
  },
  TZ: {
    dutchName: "Tanzania",
    localName: "Tanzania",
    phonePrefix: "255",
    englishName: "Tanzania",
  },
  TH: {
    dutchName: "Thailand",
    localName: "ประเทศไทย",
    phonePrefix: "66",
    englishName: "Thailand",
  },
  TG: {
    dutchName: "Togo",
    localName: "Togo",
    phonePrefix: "228",
    englishName: "Togo",
  },
  TK: {
    dutchName: "Tokelau",
    localName: "Tokelau",
    phonePrefix: "690",
    englishName: "Tokelau",
  },
  TO: {
    dutchName: "Tonga",
    localName: "Tonga",
    phonePrefix: "676",
    englishName: "Tonga",
  },
  TT: {
    dutchName: "Trinidad en Tobago",
    localName: "Trinidad and Tobago",
    phonePrefix: "1868",
    englishName: "Trinidad and Tobago",
  },
  TD: {
    dutchName: "Tsjaad",
    localName: "Tchad",
    phonePrefix: "235",
    englishName: "Chad",
  },
  CZ: {
    dutchName: "Tsjechië",
    localName: "Česká republika",
    phonePrefix: "420",
    englishName: "Czech Republic",
  },
  TN: {
    dutchName: "Tunesië",
    localName: "تونس",
    phonePrefix: "216",
    englishName: "Tunisia",
  },
  TR: {
    dutchName: "Turkije",
    localName: "Türkiye",
    phonePrefix: "90",
    englishName: "Turkey",
  },
  TM: {
    dutchName: "Turkmenistan",
    localName: "Türkmenistan",
    phonePrefix: "993",
    englishName: "Turkmenistan",
  },
  TC: {
    dutchName: "Turks- en Caicoseilanden",
    localName: "Turks and Caicos Islands",
    phonePrefix: "1649",
    englishName: "Turks and Caicos Islands",
  },
  TV: {
    dutchName: "Tuvalu",
    localName: "Tuvalu",
    phonePrefix: "688",
    englishName: "Tuvalu",
  },
  UY: {
    dutchName: "Uruguay",
    localName: "Uruguay",
    phonePrefix: "598",
    englishName: "Uruguay",
  },
  VU: {
    dutchName: "Vanuatu",
    localName: "Vanuatu",
    phonePrefix: "678",
    englishName: "Vanuatu",
  },
  VA: {
    dutchName: "Vaticaanstad",
    localName: "Città del Vaticano",
    phonePrefix: "379",
    englishName: "Vatican City",
  },
  VE: {
    dutchName: "Venezuela",
    localName: "Venezuela",
    phonePrefix: "58",
    englishName: "Venezuela",
  },
  GB: {
    dutchName: "Verenigd Koninkrijk",
    localName: "United Kingdom",
    phonePrefix: "44",
    englishName: "United Kingdom",
  },
  AE: {
    dutchName: "Verenigde Arabische Emiraten",
    localName: "الإمارات العربية المتحدة",
    phonePrefix: "971",
    englishName: "United Arab Emirates",
  },
  US: {
    dutchName: "Verenigde Staten",
    localName: "United States",
    phonePrefix: "1",
    englishName: "United States",
  },
  VN: {
    dutchName: "Vietnam",
    localName: "Việt Nam",
    phonePrefix: "84",
    englishName: "Vietnam",
  },
  WF: {
    dutchName: "Wallis en Futuna",
    localName: "Wallis-et-Futuna",
    phonePrefix: "681",
    englishName: "Wallis and Futuna",
  },
  EH: {
    dutchName: "Westelijke Sahara",
    localName: "الصحراء الغربية",
    phonePrefix: "212",
    englishName: "Western Sahara",
  },
  BY: {
    dutchName: "Wit-Rusland",
    localName: "Беларусь",
    phonePrefix: "375",
    englishName: "Belarus",
  },
  ZM: {
    dutchName: "Zambia",
    localName: "Zambia",
    phonePrefix: "260",
    englishName: "Zambia",
  },
  ZW: {
    dutchName: "Zimbabwe",
    localName: "Zimbabwe",
    phonePrefix: "263",
    englishName: "Zimbabwe",
  },
  ZA: {
    dutchName: "Zuid-Afrika",
    localName: "South Africa",
    phonePrefix: "27",
    englishName: "South Africa",
  },
  GS: {
    dutchName: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
    localName: "South Georgia and the South Sandwich Islands",
    phonePrefix: "500",
    englishName: "South Georgia and the South Sandwich Islands",
  },
  KR: {
    dutchName: "Zuid-Korea",
    localName: "대한민국",
    phonePrefix: "82",
    englishName: "South Korea",
  },
  SS: {
    dutchName: "Zuid-Soedan",
    localName: "South Sudan",
    phonePrefix: "211",
    englishName: "South Sudan",
  },
  SE: {
    dutchName: "Zweden",
    localName: "Sverige",
    phonePrefix: "46",
    englishName: "Sweden",
  },
  CH: {
    dutchName: "Zwitserland",
    localName: "Schweiz/Suisse/Svizzera/Svizra",
    phonePrefix: "41",
    englishName: "Switzerland",
  },
  AX: {
    dutchName: "Åland",
    localName: "Åland",
    phonePrefix: "358",
    englishName: "Åland",
  },
  HU: {
    dutchName: "Hongarije",
    localName: "Magyarország",
    phonePrefix: "36",
    englishName: "Hungary",
  },
  MM: {
    dutchName: "Myanmar",
    localName: "မြန်မာ",
    phonePrefix: "95",
    englishName: "Myanmar",
  },
  NA: {
    dutchName: "Namibië",
    localName: "Namibia",
    phonePrefix: "264",
    englishName: "Namibia",
  },
  NR: {
    dutchName: "Nauru",
    localName: "Nauru",
    phonePrefix: "674",
    englishName: "Nauru",
  },
  NL: {
    dutchName: "Nederland",
    localName: "Nederland",
    phonePrefix: "31",
    englishName: "Netherlands",
  },
  NP: {
    dutchName: "Nepal",
    localName: "नेपाल",
    phonePrefix: "977",
    englishName: "Nepal",
  },
  NI: {
    dutchName: "Nicaragua",
    localName: "Nicaragua",
    phonePrefix: "505",
    englishName: "Nicaragua",
  },
  NC: {
    dutchName: "Nieuw-Caledonië",
    localName: "Nouvelle-Calédonie",
    phonePrefix: "687",
    englishName: "New Caledonia",
  },
  NZ: {
    dutchName: "Nieuw-Zeeland",
    localName: "New Zealand",
    phonePrefix: "64",
    englishName: "New Zealand",
  },
  NE: {
    dutchName: "Niger",
    localName: "Niger",
    phonePrefix: "227",
    englishName: "Niger",
  },
  NG: {
    dutchName: "Nigeria",
    localName: "Nigeria",
    phonePrefix: "234",
    englishName: "Nigeria",
  },
  NU: {
    dutchName: "Niue",
    localName: "Niue",
    phonePrefix: "683",
    englishName: "Niue",
  },
  MK: {
    dutchName: "Noord-Macedonië",
    localName: "Северна Македонија",
    phonePrefix: "389",
    englishName: "North Macedonia",
  },
  KP: {
    dutchName: "Noord-Korea",
    localName: "조선민주주의인민공화국",
    phonePrefix: "850",
    englishName: "North Korea",
  },
  MP: {
    dutchName: "Noordelijke Marianen",
    localName: "Northern Mariana Islands",
    phonePrefix: "1670",
    englishName: "Northern Mariana Islands",
  },
  NO: {
    dutchName: "Noorwegen",
    localName: "Norge",
    phonePrefix: "47",
    englishName: "Norway",
  },
  MZ: {
    dutchName: "Mozambique",
    localName: "Moçambique",
    phonePrefix: "258",
    englishName: "Mozambique",
  },
};
